var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 4.83073H9.83268V6.4974H8.16602V4.83073ZM8.16602 8.16406H9.83268V13.1641H8.16602V8.16406ZM8.99935 0.664062C4.39935 0.664062 0.666016 4.3974 0.666016 8.9974C0.666016 13.5974 4.39935 17.3307 8.99935 17.3307C13.5993 17.3307 17.3327 13.5974 17.3327 8.9974C17.3327 4.3974 13.5993 0.664062 8.99935 0.664062ZM8.99935 15.6641C5.32435 15.6641 2.33268 12.6724 2.33268 8.9974C2.33268 5.3224 5.32435 2.33073 8.99935 2.33073C12.6743 2.33073 15.666 5.3224 15.666 8.9974C15.666 12.6724 12.6743 15.6641 8.99935 15.6641Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.168e316dcc86ea49284dbd6f1494aac8.svg";
export { ForwardRef as ReactComponent };